import { render, staticRenderFns } from "./Address.vue?vue&type=template&id=3be7d8aa&scoped=true"
import script from "./Address.vue?vue&type=script&lang=js"
export * from "./Address.vue?vue&type=script&lang=js"
import style0 from "./Address.vue?vue&type=style&index=0&id=3be7d8aa&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be7d8aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-life-proof-portal/hive-life-proof-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3be7d8aa')) {
      api.createRecord('3be7d8aa', component.options)
    } else {
      api.reload('3be7d8aa', component.options)
    }
    module.hot.accept("./Address.vue?vue&type=template&id=3be7d8aa&scoped=true", function () {
      api.rerender('3be7d8aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Address.vue"
export default component.exports